import { useTranslation } from "@/hooks/useTranslation/useTranslation"
import { Link } from "react-router"
import { formatInt, localeForLanguage } from "../supplierDashboardStore"
import type { DashboardWidgetProps } from "../widgetRegistry"
import { DashboardRow } from "./DashboardRow"

const MC_BASE = "/material-compliance"

export function InReviewWidget({ stats, loadFailed }: DashboardWidgetProps) {
  const { translate, currentLanguage } = useTranslation()
  const locale = localeForLanguage(currentLanguage)
  if (stats.inReviewTop.length === 0) {
    // After a failed load the list is unknown, not empty: no "nothing here".
    if (loadFailed) return null
    return (
      <div className="py-6 text-sm text-grey5">
        {translate("MC_SSD_EMPTY_LIST")}
      </div>
    )
  }
  return (
    <div>
      {stats.inReviewTop.map((item) => {
        const processing =
          item.lifecycleStatus === "pending" ||
          item.lifecycleStatus === "processing"
        const subtitle = processing
          ? translate("MC_SSD_ROW_PROCESSING")
          : item.receivedAt
            ? translate("MC_SSD_ROW_RECEIVED", {
                date: new Date(item.receivedAt).toLocaleDateString(locale),
              })
            : undefined
        return (
          <DashboardRow
            key={item.declarationId}
            title={
              item.supplierId ? (
                <Link
                  to={`${MC_BASE}/supplier-studio/declarations?supplier_id=${encodeURIComponent(item.supplierId)}`}
                  className="font-semibold text-white underline decoration-grey5 underline-offset-4 hover:decoration-white"
                >
                  {item.supplierName ?? item.declarationId}
                </Link>
              ) : (
                <span className="font-semibold text-white">
                  {item.supplierName ?? item.declarationId}
                </span>
              )
            }
            subtitle={subtitle}
            metric={formatInt(item.articlesLinked, locale)}
            metricLabel={translate("MC_SSD_ROW_ARTICLES_LINKED")}
            /* A PROCESSING ROW IS NOT A DEAD ROW. The review route opens on a
               declaration that is still being read, landing on the live board — so
               the row offers that instead of a bare "processing" label, and says
               what it leads to. The state itself is still on the row: it is the
               subtitle above. */
            action={{
              label: processing
                ? translate("MC_DECL_ACTION_WATCH_RUN")
                : translate("MC_SSD_ROW_REVIEW"),
              to: `${MC_BASE}/supplier-studio/declarations/${item.declarationId}/review`,
            }}
          />
        )
      })}
    </div>
  )
}
